module.exports = __webpack_public_path__ + "img/logo.29525497.png";